import script from "./JobDescriptionPromptPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDescriptionPromptPage.vue?vue&type=script&setup=true&lang=js"

import "@/styles/console.css?vue&type=style&index=0&lang=css&external"
import "@/styles/tool-page.css?vue&type=style&index=1&lang=css&external"
import "./JobDescriptionPromptPage.vue?vue&type=style&index=2&id=b20b224e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b20b224e"]])

export default __exports__